package com.htmlagent.site.i18n

// Generated from i18n/strings.json. Do not edit: edit the JSON and rebuild.

/** The texts of the chat area. */
interface ChatStrings {
    val downloaded: String

    val downloadedTip: String

    val emptyState: String

    val untitled: String

    val statusWorking: String

    val statusReady: String

    val agentName: String

    val copy: String

    val copyTitle: String

    val copied: String

    val editMessage: String

    val deleteMessage: String

    val editField: String

    val saveEdit: String

    val cancelEdit: String

    val editHint: String

    val deleteConfirmTitle: String

    val deleteConfirmDetail: String

    val retry: String

    val retryTitle: String

    val askAgain: String

    val askAgainTitle: String

    val noPage: String

    val placeholder: String

    val composerLabel: String

    val send: String

    val stop: String

    val enterKey: String

    val enterHint: String

    val newLineKey: String

    val newLineHint: String

    fun versionCount(count: Int): String

    fun startedToday(time: String): String

    fun worked(seconds: Int): String

    fun version(version: String): String

    fun sizeInKb(kilobytes: Int): String

    val whatNowTitle: String

    val whatNowDownload: String

    val whatNowShare: String

    val regionLabel: String

    val describeForMe: String

    val usageLabel: String

    fun usageTokens(value: String): String

    fun usageInput(value: String): String

    fun usageOutput(value: String): String

    val usageEstimate: String

    fun usageTurns(count: Int): String

    val attachImages: String

    fun removeImage(n: Int): String

    fun referenceImage(n: Int): String

    fun imagesLimit(max: Int): String

    val imageUnreadable: String

    val placeholderShort: String
}

/** The chat area in Spanish. */
internal object SpanishChatStrings : ChatStrings {
    override val downloaded: String = "Ya es tuya. El fichero está en tus descargas: ábrelo con doble clic y se ve en cualquier navegador, con conexión o sin ella. Si quieres cambiar algo, pídemelo y cambio solo esa parte."

    override val downloadedTip: String = "¿Te ha servido? Invítame a un café"

    override val emptyState: String = "Cuéntame qué web necesitas y para quién es."

    override val untitled: String = "Describe la página que quieres"

    override val statusWorking: String = "Trabajando"

    override val statusReady: String = "Lista"

    override val agentName: String = "Agente"

    override val copy: String = "Copiar"

    override val copyTitle: String = "Copiar el texto de la respuesta"

    override val copied: String = "Copiado"

    override val editMessage: String = "Editar"

    override val deleteMessage: String = "Eliminar"

    override val editField: String = "Nuevo texto del mensaje"

    override val saveEdit: String = "Guardar"

    override val cancelEdit: String = "Cancelar"

    override val editHint: String = "Se volverá a enviar y se descartará lo que viene después."

    override val deleteConfirmTitle: String = "Borrar este mensaje"

    override val deleteConfirmDetail: String = "Y todo lo que sigue. No se puede deshacer."

    override val retry: String = "Volver a intentarlo"

    override val retryTitle: String = "Volver a pedir lo mismo"

    override val askAgain: String = "Pedir otra versión"

    override val askAgainTitle: String = "Pedir lo mismo otra vez y quedarte con la que más te guste"

    override val noPage: String = "Esta vez no ha salido ninguna página. No se ha perdido nada de lo anterior: vuelve a intentarlo, o cuéntamelo con otras palabras."

    override val placeholder: String = "Una página para mi cafetería de barrio…"

    override val composerLabel: String = "Describe la página que quieres"

    override val send: String = "Enviar"

    override val stop: String = "Parar la generación"

    override val enterKey: String = "Enter"

    override val enterHint: String = "para enviar"

    override val newLineKey: String = "Mayús+Enter"

    override val newLineHint: String = "salto de línea"

    override fun versionCount(count: Int): String = when (count) {
        1 -> "1 versión"
        else -> "$count versiones"
    }

    override fun startedToday(time: String): String = "Hoy · $time"

    override fun worked(seconds: Int): String = "trabajó $seconds s"

    override fun version(version: String): String = "Versión $version"

    override fun sizeInKb(kilobytes: Int): String = "$kilobytes KB"

    override val whatNowTitle: String = "¿Y ahora qué?"

    override val whatNowDownload: String = "Descárgala: ese fichero es tu página. Súbela a tu alojamiento o dásela a quien te lleve el dominio."

    override val whatNowShare: String = "¿Solo quieres enseñarla? Copia el enlace. Sirve para verla, no para usarla como tu web: deja de funcionar si borras la sesión."

    override val regionLabel: String = "Conversación con el agente"

    override val describeForMe: String = "Ayúdame a describirla"

    override val usageLabel: String = "Consumo de la sesión"

    override fun usageTokens(value: String): String = "$value tokens"

    override fun usageInput(value: String): String = "$value de entrada"

    override fun usageOutput(value: String): String = "$value de salida"

    override val usageEstimate: String = "importe estimado"

    override fun usageTurns(count: Int): String = when (count) {
        1 -> "1 turno"
        else -> "$count turnos"
    }

    override val attachImages: String = "Adjuntar fotos de sitios que te gusten, como referencia"

    override fun removeImage(n: Int): String = "Quitar la foto $n"

    override fun referenceImage(n: Int): String = "Foto de referencia $n"

    override fun imagesLimit(max: Int): String = "Caben $max fotos por mensaje."

    override val imageUnreadable: String = "Esa imagen no se pudo leer. Prueba con un JPEG, PNG o WebP."

    override val placeholderShort: String = "Una web para mi café…"
}

/** The chat area in English. */
internal object EnglishChatStrings : ChatStrings {
    override val downloaded: String = "It is yours now. The file is in your downloads: double-click it and it opens in any browser, online or off. If you want to change something, ask me and only that part changes."

    override val downloadedTip: String = "Did it help? Buy me a coffee"

    override val emptyState: String = "Tell me what site you need and who it is for."

    override val untitled: String = "Describe the page you want"

    override val statusWorking: String = "Working"

    override val statusReady: String = "Ready"

    override val agentName: String = "Agent"

    override val copy: String = "Copy"

    override val copyTitle: String = "Copy the text of the reply"

    override val copied: String = "Copied"

    override val editMessage: String = "Edit"

    override val deleteMessage: String = "Delete"

    override val editField: String = "New text of the message"

    override val saveEdit: String = "Save"

    override val cancelEdit: String = "Cancel"

    override val editHint: String = "It will be sent again and everything after it discarded."

    override val deleteConfirmTitle: String = "Delete this message"

    override val deleteConfirmDetail: String = "And everything after it. This cannot be undone."

    override val retry: String = "Try again"

    override val retryTitle: String = "Ask for the same thing again"

    override val askAgain: String = "Ask for another version"

    override val askAgainTitle: String = "Ask for the same thing again and keep whichever you prefer"

    override val noPage: String = "No page came out this time. Nothing before it was lost: try again, or tell me in different words."

    override val placeholder: String = "A page for my neighbourhood café…"

    override val composerLabel: String = "Describe the page you want"

    override val send: String = "Send"

    override val stop: String = "Stop the generation"

    override val enterKey: String = "Enter"

    override val enterHint: String = "to send"

    override val newLineKey: String = "Shift+Enter"

    override val newLineHint: String = "line break"

    override fun versionCount(count: Int): String = when (count) {
        1 -> "1 version"
        else -> "$count versions"
    }

    override fun startedToday(time: String): String = "Today · $time"

    override fun worked(seconds: Int): String = "worked $seconds s"

    override fun version(version: String): String = "Version $version"

    override fun sizeInKb(kilobytes: Int): String = "$kilobytes KB"

    override val whatNowTitle: String = "What now?"

    override val whatNowDownload: String = "Download it: that file is your page. Put it on your hosting, or give it to whoever runs your domain."

    override val whatNowShare: String = "Just want to show someone? Copy the link. It is for looking at, not for using as your site: it stops working if you delete the session."

    override val regionLabel: String = "Conversation with the agent"

    override val describeForMe: String = "Help me describe it"

    override val usageLabel: String = "Session usage"

    override fun usageTokens(value: String): String = "$value tokens"

    override fun usageInput(value: String): String = "$value in"

    override fun usageOutput(value: String): String = "$value out"

    override val usageEstimate: String = "estimated amount"

    override fun usageTurns(count: Int): String = when (count) {
        1 -> "1 turn"
        else -> "$count turns"
    }

    override val attachImages: String = "Attach photos of sites you like, as a reference"

    override fun removeImage(n: Int): String = "Remove photo $n"

    override fun referenceImage(n: Int): String = "Reference photo $n"

    override fun imagesLimit(max: Int): String = "A message takes up to $max photos."

    override val imageUnreadable: String = "That image could not be read. Try a JPEG, PNG or WebP."

    override val placeholderShort: String = "A page for my café…"
}
